import { useCallback, useEffect, useState } from 'react';
import { getMyInputsProfile, saveMyInputsProfile } from '../services/myInputsService';
import { MyInputsCurrentProfile } from '../types/myInputs';

export default function useMyInputsProfile(userId?: string | null) {
  const [loading, setLoading] = useState(Boolean(userId));
  const [saving, setSaving] = useState(false);
  const [profile, setProfile] = useState<MyInputsCurrentProfile | null>(null);

  const reload = useCallback(async () => {
    if (!userId) {
      setProfile(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const next = await getMyInputsProfile(userId);
      setProfile(next);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    reload();
  }, [reload]);

  const save = useCallback(async (nextProfile: MyInputsCurrentProfile, updatedBy: MyInputsCurrentProfile['updatedBy'] = 'member') => {
    if (!userId) return null;
    setSaving(true);
    try {
      const saved = await saveMyInputsProfile(userId, nextProfile, updatedBy);
      setProfile(saved);
      return saved;
    } finally {
      setSaving(false);
    }
  }, [userId]);

  return {
    loading,
    saving,
    profile,
    reload,
    save,
  };
}
